import { InjectionToken } from '@angular/core';

export const WHOAMI_BASE_PATH = new InjectionToken<string>('WHOAMI_BASE_PATH', {
  factory: () => '/v1/credential-net/users/whoami',
});

export class AccredibleAuthenticationServiceConfig {
  app: 'rp' | 'acs' | 'sl' | 'cf' | 'ler';
}
